<template>
  <section id="contact">
    <v-container fluid class="contact-section py-16">
      <v-row align="center" justify="center">
        <v-col cols="10" lg="8">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <p class="section-overline mb-2">CONTATO</p>
              <h2 class="section-title mb-4">Fale Conosco</h2>
              <p class="contact-text mb-8">
                Estamos aqui para ajudar! Se tiver dúvidas, sugestões ou
                precisar de mais informações, nossa equipe está pronta para
                atendê-lo.
              </p>

              <div class="contact-info-item d-flex align-center mb-4">
                <div class="contact-info-icon mr-4">
                  <v-icon color="primary" size="20">mdi-phone-outline</v-icon>
                </div>
                <div>
                  <p class="contact-info-label mb-0">Telefone</p>
                  <p class="contact-info-value mb-0">+xx (xx) xxxxx-xxxx</p>
                </div>
              </div>

              <div class="contact-info-item d-flex align-center">
                <div class="contact-info-icon mr-4">
                  <v-icon color="primary" size="20">mdi-email-outline</v-icon>
                </div>
                <div>
                  <p class="contact-info-label mb-0">Email</p>
                  <p class="contact-info-value mb-0">email@email.com</p>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="7">
              <v-card class="contact-form-card pa-6 pa-md-8" flat>
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Nome"
                    required
                    outlined
                    dense
                    class="mb-1"
                  />

                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                    outlined
                    dense
                    class="mb-1"
                  />

                  <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="Mensagem"
                    required
                    outlined
                    dense
                    rows="4"
                  />

                  <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    large
                    depressed
                    class="mt-2 btn-primary-custom"
                  >
                    Enviar Mensagem
                    <v-icon class="ml-2" small>mdi-send</v-icon>
                  </v-btn>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar.enabled"
      timeout="3000"
      right
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.enabled = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "O campo nome é obrigatório",
      (v) => (v && v.length >= 6) || "O nome precisa ter mais de 6 caracteres",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "O campo email é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "O E-mail precisa ser válido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "O campo de texto é obrigatório",
      (v) => (v && v.length >= 10) || "Mínimo de 10 caracteres",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
  }),
  methods: {
    submit() {},
  },
};
</script>
<style scoped>
.contact-section {
  background-color: var(--ds-gray-bg);
}
.section-overline {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--ds-primary);
  text-transform: uppercase;
}
.section-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: var(--ds-ink);
  letter-spacing: -0.3px;
  line-height: 1.2;
}
.contact-text {
  font-size: 0.95rem;
  font-weight: 300;
  color: var(--ds-gray);
  line-height: 1.7;
}
.contact-info-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--ds-blue-100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.contact-info-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.contact-info-value {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--ds-ink);
}
.contact-form-card {
  background: var(--ds-surface-white);
  border-radius: 16px !important;
  border: 1px solid #eee;
}
.btn-primary-custom {
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0.2px;
}
@media (max-width: 960px) {
  .section-title {
    font-size: 1.75rem;
  }
}
</style>
